<div class="totalContainer">
  <div class="main_box">
    <img
      src="{{ onPassiveBaseUrl }}onpassive-october(3)/images/robot.png"
      class="img-fluid vert-move"
      alt="image"
    />
    <!--<img src="images/hand.png" class="img-fluid hand" alt="image">-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="logo">
            <img
              src="{{ onPassiveBaseUrl }}onpassive-october(3)/images/logo.png"
              class="img-fluid"
              alt="image"
            />
          </div>
        </div>
      </div>
      <div class="row justify-content-end">
        <div class="col-lg-10 col-md-12">
          <div class="row">
            <div class="col-lg-7">
              <div class="left_first_box">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  viewBox="0 0 1956 300"
                >
                  <!-- Symbol -->
                  <symbol id="s-text">
                    <text text-anchor="middle" x="50%" y="50%" dy=".35em">
                      NEW REVOLUTIONIZED
                    </text>
                  </symbol>

                  <!-- Duplicate symbols -->
                  <use xlink:href="#s-text" class="text"></use>
                  <use xlink:href="#s-text" class="text"></use>
                  <use xlink:href="#s-text" class="text"></use>
                  <use xlink:href="#s-text" class="text"></use>
                  <use xlink:href="#s-text" class="text"></use>
                </svg>
             
                <h1>INTERNET MARKETING SOLUTIONS</h1>
                <div class="video_box acc_panel anim_in">
                  <video
                    id="my-video"
                    class="video-js video-size w-100 h-auto"
                    controls
                    preload="auto"
                    poster="{{ myLinksS3URL }}images/Image0231.png"
                    data-setup="{}"
                    autoplay="true"
                    muted
                  >
                    <source
                      src="{{
                        myLinksS3URL
                      }}videos/Onpassive_launching_page_video2.mp4"
                      type="video/mp4"
                    />
                  </video>
                </div>
              </div>
            </div>
            <div class="col-lg-5">
              <div class="right_box">
                <div class="launching_box">
                  <h4 class="ml2 mt-3">LAUNCHING SOON!</h4>
                  <p>
                    Presenting ONPASSIVE.. an awesome earning platform that
                    gives you a complete financial freedom and earning
                    opportunity. Enjoy a quality time with your dear ones as
                    ONPASSIVE is 100% automated and you do not need to give
                    hours of time for promotion. Enjoy maximum residual income
                    for a lifetime with our one-of-a-kind business model
                  </p>
                </div>

                <a
                  href="/registration/user?reg={{ userId }}"
                  name="regform"
                  target="_blank"
                  rel="noopener"
                  class="btn11"
                >
                  <span>BECOME A FOUNDER NOW</span>

                  <div class="transition"></div>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
